import { type ReactNode } from 'react'
import { AuthInterfaceLanguageSelect } from '@/features/auth/auth-interface-language-select'
import { Badge } from '@/components/ui/badge'

function LogoSymbol({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="-75 -75 300 300" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fill="currentColor"
          d="m43.08 63.57h-42.08v22h45.27c9.86 0 17.86 8 17.86 17.86v45.27h22v-42.08c0-2.26-0.9-4.42-2.5-6.02l-34.53-34.53c-1.6-1.6-3.77-2.5-6.02-2.5z"
        />
        <path
          fill="currentColor"
          d="m107.62 85.13h42.08v-22h-45.27c-9.86 0-17.86-7.99-17.86-17.85v-45.28h-22v42.08c0 2.26 0.9 4.43 2.5 6.02l34.53 34.53c1.6 1.6 3.76 2.5 6.02 2.5z"
        />
      </g>
    </svg>
  )
}

type AuthLayoutProps = {
  children: ReactNode
  hideInterfaceLanguageSelect?: boolean
}

export function AuthLayout({ children, hideInterfaceLanguageSelect = false }: AuthLayoutProps) {
  return (
    <div className="h-svh flex items-center justify-center">
      {!hideInterfaceLanguageSelect ? (
        <div className="fixed inset-e-4 bottom-4 z-10 sm:inset-e-6 sm:bottom-6">
          <AuthInterfaceLanguageSelect />
        </div>
      ) : null}
      <div className="mx-auto flex w-full max-w-lg flex-col justify-center space-y-2 py-8 sm:p-8">
        <div className="mb-4 flex flex-col gap-2">
          <div className="flex flex-wrap items-center gap-3">
            <LogoSymbol className="size-10 shrink-0 text-[#02FFD8]" />
            <div className="flex flex-col gap-0.5">
              <div className="flex flex-wrap items-baseline gap-2">
                <span className="text-xl font-bold tracking-tight">
                  Artem
                  <span className="text-green-600">CBAM</span>
                </span>
                <Badge variant="outline" className="font-semibold tracking-wide uppercase">
                  Operator
                </Badge>
              </div>
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
